import React from 'react';
import { MailIcon, PhoneIcon, LocationMarkerIcon } from '@heroicons/react/outline';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { clinicLocation, emailContact, mainLogo, mainTitle, reviewPage } from '../../../config';
import { newServices, newSpecialities } from '../../../utils/NewData';
import { useNavigate } from 'react-router-dom';
import { routeNames } from '../../../routes/routeNames';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-gray-200 py-10 pt-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Logo and Title */}
          <div className="space-y-3">
            <div onClick={() => navigate('/')} className="flex items-center space-x-3 cursor-pointer mb-10">
              <img src={mainLogo} alt="Logo" className="h-12" />
              <div>
                <h1 className="text-3xl text-left font-bold text-white">{mainTitle}</h1>
                <div className="flex items-center justify-center space-x-2">
                <span className="w-10 h-[1px] bg-green"></span>
                <h3 className="text-md text-white font-lato italic lg:text-md">
                  Feel the Relief
                </h3>
                <span className="w-10 h-[1px] bg-green"></span>
              </div>
              </div>
            </div>
            <div className="space-y-4 text-md">
              <a href={clinicLocation} className="flex items-center">
                <LocationMarkerIcon className="h-7 w-7 text-primary mr-2" />
                360 Conklin Rd Unit A, Brantford, ON N3T 0N5
              </a>
              <a href={"tel:+1 (226) 368-1309"} className="flex items-center">
                <PhoneIcon className="h-5 w-5 text-primary mr-2" />
                +1 (226) 368-1309
              </a>
              <a href={`mailto:${emailContact}`} target='_blank' className="flex items-center">
                <MailIcon className="h-5 w-5 text-primary mr-2" />
                info@conklinphysiochiroplus.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-3">Quick Links</h3>
            <ul className="text-lg space-y-1">
              <li><a onClick={()=>navigate(routeNames.home)} className="hover:text-primary transition">Home</a></li>
              <li><a onClick={()=>navigate(routeNames.aboutus)} className="hover:text-primary transition">About Us</a></li>
              <li><a onClick={()=>navigate(routeNames.services)} className="hover:text-primary transition">Services</a></li>
              <li><a onClick={()=>navigate(routeNames.specialities)} className="hover:text-primary transition">Specialities</a></li>
              <li><a onClick={()=>navigate(routeNames.contact)} className="hover:text-primary transition">Contact</a></li>
            </ul>
          </div>

          {/* Services and Social Media */}
          <div>
            <h3 className="text-xl font-semibold mb-3">Our Specialities</h3>
            <ul className="space-y-1 text-lg mb-4">
              {newSpecialities.map((item) => (
                <li key={item.title}><a onClick={()=>navigate(item.link)} className="hover:text-primary transition py-4">{item.title}</a></li>
              ))}
            </ul>
           
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-3">Our Services</h3>
            <ul className="space-y-1 text-lg mb-4">
              {newServices.map((item) => (
                <li key={item.title}><a onClick={()=>navigate(item.link)} className="hover:text-primary transition py-4">{item.title}</a></li>
              ))}
            </ul>
            <div className="mt-10 flex space-x-4">
              <a href="https://facebook.com" className="text-gray-200 hover:text-primary transition "><FaFacebookF /></a>
              <a href="https://twitter.com" className="text-gray-200 hover:text-primary transition"><FaTwitter /></a>
              <a href="https://instagram.com" className="text-gray-200 hover:text-primary transition"><FaInstagram /></a>
              <a href="https://linkedin.com" className="text-gray-200 hover:text-primary transition"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>
        <div className="text-center border-t border-gray-700 pt-4 mt-8">
          <p>© 2024 {mainTitle}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;